module.exports = __webpack_public_path__ + "JMS.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/JMS.jpg
// module id = 845
// module chunks = 0